import { Directive, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { WrappedControlSuperclass } from '@sama/ng-core';

@Directive()
export abstract class AbstractWrappedFormControl<
  OuterType,
  InnerType = OuterType,
> extends WrappedControlSuperclass<OuterType, InnerType> {
  /** use this or [disabled], not both */
  @Input() disable: string | boolean = false;

  protected control = new FormControl();

  constructor() {
    super();
    this.subscribeTo(this.getInput$('disable'), (disable) => {
      this.setDisabledState(!!disable);
    });
  }
}
